import React, { useState, useEffect } from "react";
import { getNotification, markRead } from "../../api/api";
import toastr from "toastr";
import "toastr/build/toastr.min.css";
import Loader from "../loader/loader";
import "../pages/search.css";
import { Link } from "react-router-dom";

const PublishNotification = (props) => {
  // const [search, setSearch] = useState(false);
  // const [searchOn, setSearchOn] = useState(false);
  const [loading, setLoading] = useState(true);
  // const [selectedUser,setSelectedUser] = useState([]);
  // const [editing, setEditing] = useState([]);
  // const [myArray, setMyArray] = useState([]);
  const [media, setMedia] = useState([]);
  const [c, setC] = useState([]);
  // const [fday,setFday] = useState([]);
  // const [fmonth,setFmonth] = useState([]);
  // const [fyear,setFyear] = useState([]);
  // const [tday,setTday] = useState([]);
  // const [tmonth,setTmonth] = useState([]);
  // const [tyear,setTyear] = useState([]);
  const [number, setNumber] = useState(0);
  // const [time,setTime] = useState('');

  useEffect(() => {
    const getNotifications = async () => {
      /* eslint-disable no-unused-vars */
      const result = await getNotification().then(
        (result) => {
          // brandImage(result.data);
          setMedia(result.data);
          setLoading(false);
        },
        (error) => {
          toastr.error("Unable to Load Data", "Error");
          setLoading(false);
        }
      );
      /* eslint-disable no-unused-vars */
    };

    getNotifications();
    // eslint-disable-line react-hooks/exhaustive-deps
    //eslint-disable-next-line
  }, [c]);

  const markReads = async (person) => {
    /* eslint-disable no-unused-vars */
    // event.preventDefault();

    const result = await markRead(person).then(
      (result) => {
        // brandImage(result.data);
        setC(result.data);
        setLoading(false);
      },
      (error) => {
        toastr.error("Unable to Load Data", "Error");
        setLoading(false);
      }
    );

    /* eslint-disable no-unused-vars */
  };

  function formatDate(string) {
    var options = { year: "numeric", month: "long", day: "numeric" };
    return new Date(string).toLocaleDateString([], options);
  }

  function formatTime(string) {
    var options = {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    };
    return new Date(string).toLocaleDateString([], options);
  }
  // const update = ()=>{
  //     setLoading(true);
  //     setTime('7 Days');
  //      }
  //      const mUpdate = ()=>{
  //         setLoading(true);
  //         setTime('30 Days');
  //          }
  //          const tMUpdate = ()=>{
  //             setLoading(true);
  //             setTime('90 Days');
  //              }
  //              const lUpdate = ()=>{
  //                 setLoading(true);
  //                 setTime('Last Quarter');
  //                  }
  //                  const mTDUpdate = ()=>{
  //                     setLoading(true);
  //                     setTime('Month To Date');
  //                      }
  //                      const TUpdate = ()=>{
  //                         setLoading(true);
  //                         setTime('Today');
  //                          }
  //                          const yUpdate = ()=>{
  //                             setLoading(true);
  //                             setTime('Yesterday');
  //                              }
  const addNumber = async () => {
    let i = number + 1;
    setNumber(i);
    setLoading(true);
  };
  const minusNumber = async () => {
    let i = number - 1;
    setNumber(i);
    setLoading(true);
  };

  if (loading) {
    return (
      <div className="content">
        <Loader />
      </div>
    );
  } else {
    return (
      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-sm-12">
              <div className="card ">
                <div className="card-header filter">
                  <h3 className="card-title">Notifications</h3>

                  {/* <ul className="navbar-nav ml-auto ">
                      <li className="nav-item">
                        <a
                          className="nav-link"
                          data-widget="navbar-search"
                          href="#!"
                          role="button"
                          onClick={(event) => {
                            event.preventDefault();
                            setSearchOn(!searchOn);
                          }}
                        >
                          <i className="fas fa-search"></i>
                        </a>
                        <div
                          className={
                            searchOn&&editing.cloudKey&&editing.cloudSecretV2
                              ? "navbar-search-block"
                              : "navbar-search-block none"
                          }
                        >
                          <form
                            className="form-inline"
                            onSubmit={(event) => {
                              event.preventDefault();
                              setSearch(true);
                              setTime('');
                              setLoading(true);
                            }}
                          >
                            <div className="input-group input-group-sm">
                            <label>From</label>&nbsp;
                              <input
                                className="form-control form-control-navbar"
                                type="search"
                                placeholder="yyyy-mm-dd"
                                aria-label="yyyy-mm-dd"
                                value={selectedUser}
                                onChange={(event) => {setSelectedUser(event.target.value);setSearch(false);}}
                              />&nbsp;&nbsp;
                              <label>To</label>&nbsp;
                              <input
                                className="form-control form-control-navbar"
                                type="search"
                                placeholder="yyyy-mm-dd"
                                aria-label="yyyy-mm-dd"
                                value={myArray}
                                onChange={(event) => {setMyArray(event.target.value);setSearch(false);}}
                              />
                              <div className="input-group-append">
                                <button className="btn btn-navbar" type="submit">
                                  <i className="fas fa-search"></i>
                                </button>
                                <button
                                  className="btn btn-navbar"
                                  type="button"
                                  data-widget="navbar-search"
                                  onClick={(event) => {
                                    event.preventDefault();
                                    setSearch(false);
                                    setSearchOn(false);
                                  }}
                                >
                                  <i className="fas fa-times"></i>
                                </button>
                              </div>
                            </div>
                          </form>
                        </div>
                      </li>
                      <li>
                      <div className="btn-group">
                                          <button
                                            type="button"
                                            className="btn btn-default"
                                          >
                                            {time?time:'Time Frame'}
                                          </button>
                                          <button
                                            type="button"
                                            className="btn btn-default dropdown-toggle dropdown-icon"
                                            data-toggle="dropdown"
                                            aria-expanded="false"
                                            disabled={editing.cloudKey&&editing.cloudSecretV2?false:true}
                                          >
                                            <span className="sr-only">
                                              Toggle Dropdown
                                            </span>
                                          </button>
                                          <div
                                            className="dropdown-menu"
                                            role="menu"
                                            
                                          >
                                            <button
                                              className="dropdown-item"
                                              name="7 Days"
                                              onClick={update}
                                              

                                            >
                                              7 Days
                                            </button>
                                            <button
                                              className="dropdown-item"
                                              onClick={mUpdate}
                                            >
                                             30 days
                                            </button>
                                            <button
                                              className="dropdown-item"
                                              onClick={tMUpdate}
                                            >
                                             90 Days
                                             </button>
                                            <button
                                            className="dropdown-item"
                                            onClick={lUpdate}
                                            >
                                              Last Quarter
                                            </button>
                                            <button
                                            className="dropdown-item"
                                            onClick={mTDUpdate}
                                            >
                                              Month to Date
                                            </button>
                                            <button
                                            className="dropdown-item"
                                            onClick={TUpdate}
                                            >
                                              Today
                                            </button>
                                            <button
                                            className="dropdown-item"
                                            onClick={yUpdate}
                                            >
                                              Yesterday
                                            </button>
                                         

                                        
                                          </div>
                                        </div>
                                        </li>
                    
                    </ul> */}
                </div>
                {/* /.card-header */}
                <div className="card-body">
                  <div className="row">
                    <div className="col-sm-12">
                      <div className="form-group">
                        <div className="row" style={{ marginTop: "10px" }}>
                          <div className="col-sm-12">
                            <div style={{ paddingBottom: "60px" }}>
                              <table
                                id="appadmin"
                                className="table table-bordered table-hover dataTable dtr-inline"
                                role="grid"
                                aria-describedby="example2_info"
                              >
                                <thead>
                                  <tr role="row">
                                    <th
                                      className="sorting_asc"
                                      tabIndex={0}
                                      aria-controls="example2"
                                      rowSpan={1}
                                      colSpan={1}
                                    >
                                      Date
                                    </th>
                                    <th
                                      className="sorting_asc"
                                      tabIndex={0}
                                      aria-controls="example2"
                                      rowSpan={1}
                                      colSpan={1}
                                    >
                                      Name
                                    </th>
                                    <th
                                      className="sorting_asc"
                                      tabIndex={0}
                                      aria-controls="example2"
                                      rowSpan={1}
                                      colSpan={1}
                                    >
                                      Message
                                    </th>
                                    <th
                                      className="sorting"
                                      tabIndex={0}
                                      aria-controls="example2"
                                      rowSpan={1}
                                      colSpan={1}
                                    >
                                      View
                                    </th>
                                  </tr>
                                </thead>

                                <tbody>
                                  {media
                                    .sort((a, b) => (a.date > b.date ? -1 : 1))
                                    .map((person, index) => (
                                      <tr
                                        role="row"
                                        className="even"
                                        key={index}
                                        style={
                                          person.read === false
                                            ? { opacity: 0.8, color: "#808080" }
                                            : null
                                        }
                                      >
                                        <td
                                          className="dtr-control sorting_1"
                                          tabIndex={0}
                                        >
                                          {formatTime(person.date)}
                                        </td>

                                        <td
                                          className="dtr-control sorting_1"
                                          tabIndex={1}
                                        >
                                          {person.itemtype === null
                                            ? person.redirect
                                            : person.itemtype}
                                        </td>

                                        <td
                                          className="dtr-control sorting_1"
                                          tabIndex={1}
                                          style={{ fontSize: 15 }}
                                        >
                                          {person.message}
                                        </td>

                                        <td
                                          className="dtr-control sorting_1"
                                          tabIndex={1}
                                        >
                                          <Link
                                            to={
                                              person.redirect === "analytics"
                                                ? "/analytics"
                                                : person.redirect === "footer"
                                                  ? "/footer"
                                                  : person.redirect === "ticker"
                                                    ? "/tickers"
                                                    : person.redirect === "menu"
                                                      ? "/menu"
                                                      : person.redirect ===
                                                            "element" &&
                                                          person.itemtype !==
                                                            "tabItem" &&
                                                          person.itemtype !==
                                                            "textGrid" &&
                                                          person.itemtype !==
                                                            "highlightTextGrid"
                                                        ? "/item/" +
                                                          person.itemtype +
                                                          "/" +
                                                          person.itemid
                                                        : (person.redirect ===
                                                              "element" &&
                                                              person.itemtype ===
                                                                "textGrid") ||
                                                            (person.redirect ===
                                                              "element" &&
                                                              person.itemtype ===
                                                                "highlightTextGrid")
                                                          ? "/" +
                                                            person.itemtype +
                                                            "/" +
                                                            person.itemid
                                                          : person.redirect ===
                                                                "element" &&
                                                              person.itemtype ===
                                                                "tabItem"
                                                            ? "/tab/" +
                                                              person.itemid
                                                            : person.redirect ===
                                                                  "page" &&
                                                                person.itemtype ===
                                                                  "normalPage"
                                                              ? "/page/" +
                                                                person.itemid
                                                              : "/" +
                                                                (
                                                                  person.itemtype +
                                                                  ""
                                                                ).toLowerCase() +
                                                                "/" +
                                                                person.itemid
                                            }
                                          >
                                            <button
                                              type="#!"
                                              onClick={(event) =>
                                                markReads(person._id)
                                              }
                                              className="btn btn-light"
                                              style={{
                                                width: "100px",
                                                marginRight: "6px",
                                              }}
                                            >
                                              {person.redirect === null
                                                ? person.itemtype
                                                : person.redirect}
                                            </button>
                                          </Link>
                                        </td>
                                      </tr>
                                    ))}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* /.card-body */}
                {/* <div className="card-footer text-center">
                  <button onClick={minusNumber} disabled={number===0?true:false}><i className="fas fa-angle-left "></i></button>&nbsp;{number}&nbsp;<button onClick={addNumber} disabled={media.length<10?true:false}><i className="fas fa-angle-right"></i></button>
                  </div> */}
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
};

export default PublishNotification;
